// extracted by mini-css-extract-plugin
export var actionText = "_ni-4";
export var container = "_ni-0";
export var leftSection = "_ni-1";
export var rightSection = "_ni-2";
export var settingsButton = "_ni-6";
export var settingsIcon = "_ni-7";
export var shortcut = "_ni-5";
export var shortcutGroup = "_ni-3";